// Types for hierarchical meal report data
export interface StateMealData {
  serialNo: number;
  stateUT: string;
  totalSchools: number;
  reported: { count: number; percentage: number };
  notReported: { count: number; percentage: number };
  holiday: number;
  mealServedPercentage: number;
  mealNotServedPercentage: number;
  studentEnrolment: number;
  pabApproved: number | string;
  reportingSchoolsEnrolment: number;
  enrolmentPercentage: number;
  availedMeals: number;
  availedMealsPercentage: number;
}

export interface DistrictMealData {
  serialNo: number;
  district: string;
  totalSchools: number;
  reported: { count: number; percentage: number };
  notReported: { count: number; percentage: number };
  holiday: number;
  mealServedPercentage: number;
  mealNotServedPercentage: number;
  studentEnrolment: number;
  reportingSchoolsEnrolment: number;
  enrolmentPercentage: number;
  availedMeals: number;
  availedMealsPercentage: number;
}

export interface BlockMealData {
  serialNo: number;
  block: string;
  totalSchools: number;
  reported: { count: number; percentage: number };
  notReported: { count: number; percentage: number };
  holiday: number;
  mealServedPercentage: number;
  mealNotServedPercentage: number;
  studentEnrolment: number;
  reportingSchoolsEnrolment: number;
  enrolmentPercentage: number;
  availedMeals: number;
  availedMealsPercentage: number;
}

export interface VillageMealData {
  serialNo: number;
  udiseCode: string;
  schoolName: string;
  category: string;
  type: string;
  enrolment: number;
  holiday: string;
  reportingStatus: string;
  mealsServed: number;
}

// State level data
export const stateMealData: StateMealData[] = [
  {
    serialNo: 1,
    stateUT: "ANDHRA PRADESH",
    totalSchools: 43907,
    reported: { count: 42000, percentage: 95.66 },
    notReported: { count: 1907, percentage: 4.34 },
    holiday: 0,
    mealServedPercentage: 99.5,
    mealNotServedPercentage: 0.5,
    studentEnrolment: 4500000,
    pabApproved: 4200000,
    reportingSchoolsEnrolment: 4305000,
    enrolmentPercentage: 95.66,
    availedMeals: 3850000,
    availedMealsPercentage: 89.4
  },
  {
    serialNo: 2,
    stateUT: "TELANGANA",
    totalSchools: 28000,
    reported: { count: 26500, percentage: 94.64 },
    notReported: { count: 1500, percentage: 5.36 },
    holiday: 0,
    mealServedPercentage: 98.2,
    mealNotServedPercentage: 1.8,
    studentEnrolment: 2800000,
    pabApproved: 2600000,
    reportingSchoolsEnrolment: 2650000,
    enrolmentPercentage: 94.64,
    availedMeals: 2350000,
    availedMealsPercentage: 88.7
  },
  {
    serialNo: 3,
    stateUT: "KARNATAKA",
    totalSchools: 48000,
    reported: { count: 45000, percentage: 93.75 },
    notReported: { count: 3000, percentage: 6.25 },
    holiday: 0,
    mealServedPercentage: 92.8,
    mealNotServedPercentage: 7.2,
    studentEnrolment: 3200000,
    pabApproved: 2900000,
    reportingSchoolsEnrolment: 3000000,
    enrolmentPercentage: 93.75,
    availedMeals: 2750000,
    availedMealsPercentage: 91.7
  },
  {
    serialNo: 4,
    stateUT: "TAMIL NADU",
    totalSchools: 42000,
    reported: { count: 40000, percentage: 95.24 },
    notReported: { count: 2000, percentage: 4.76 },
    holiday: 0,
    mealServedPercentage: 97.5,
    mealNotServedPercentage: 2.5,
    studentEnrolment: 3800000,
    pabApproved: 3500000,
    reportingSchoolsEnrolment: 3619000,
    enrolmentPercentage: 95.24,
    availedMeals: 3200000,
    availedMealsPercentage: 88.4
  },
  {
    serialNo: 5,
    stateUT: "KERALA",
    totalSchools: 12000,
    reported: { count: 11500, percentage: 95.83 },
    notReported: { count: 500, percentage: 4.17 },
    holiday: 0,
    mealServedPercentage: 96.8,
    mealNotServedPercentage: 3.2,
    studentEnrolment: 1200000,
    pabApproved: 1100000,
    reportingSchoolsEnrolment: 1150000,
    enrolmentPercentage: 95.83,
    availedMeals: 1050000,
    availedMealsPercentage: 91.3
  },
  {
    serialNo: 6,
    stateUT: "MAHARASHTRA",
    totalSchools: 65000,
    reported: { count: 60000, percentage: 92.31 },
    notReported: { count: 5000, percentage: 7.69 },
    holiday: 0,
    mealServedPercentage: 90.5,
    mealNotServedPercentage: 9.5,
    studentEnrolment: 4200000,
    pabApproved: 3800000,
    reportingSchoolsEnrolment: 3876923,
    enrolmentPercentage: 92.31,
    availedMeals: 3450000,
    availedMealsPercentage: 89.0
  },
  {
    serialNo: 7,
    stateUT: "GUJARAT",
    totalSchools: 55000,
    reported: { count: 52000, percentage: 94.55 },
    notReported: { count: 3000, percentage: 5.45 },
    holiday: 0,
    mealServedPercentage: 93.2,
    mealNotServedPercentage: 6.8,
    studentEnrolment: 3500000,
    pabApproved: 3200000,
    reportingSchoolsEnrolment: 3309000,
    enrolmentPercentage: 94.55,
    availedMeals: 2950000,
    availedMealsPercentage: 89.2
  },
  {
    serialNo: 8,
    stateUT: "MADHYA PRADESH",
    totalSchools: 88200,
    reported: { count: 85369, percentage: 96.8 },
    notReported: { count: 2831, percentage: 3.2 },
    holiday: 0,
    mealServedPercentage: 94.1,
    mealNotServedPercentage: 5.9,
    studentEnrolment: 5800000,
    pabApproved: "TBD",
    reportingSchoolsEnrolment: 5614400,
    enrolmentPercentage: 96.8,
    availedMeals: 5200000,
    availedMealsPercentage: 92.6
  },
  {
    serialNo: 9,
    stateUT: "DELHI",
    totalSchools: 2800,
    reported: { count: 2680, percentage: 95.71 },
    notReported: { count: 120, percentage: 4.29 },
    holiday: 0,
    mealServedPercentage: 98.2,
    mealNotServedPercentage: 1.8,
    studentEnrolment: 450000,
    pabApproved: 420000,
    reportingSchoolsEnrolment: 430714,
    enrolmentPercentage: 95.71,
    availedMeals: 380000,
    availedMealsPercentage: 88.2
  }
];

// District level data for all states
export const districtMealData: { [state: string]: DistrictMealData[] } = {
  "ANDHRA PRADESH": [
    {
      serialNo: 1,
      district: "ALLURI SITHARAMA RAJU",
      totalSchools: 2676,
      reported: { count: 2602, percentage: 97.23 },
      notReported: { count: 74, percentage: 2.77 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 90875,
      reportingSchoolsEnrolment: 89077,
      enrolmentPercentage: 98.02,
      availedMeals: 80614,
      availedMealsPercentage: 90.5
    },
    {
      serialNo: 2,
      district: "ANAKAPALLI",
      totalSchools: 1407,
      reported: { count: 1396, percentage: 99.22 },
      notReported: { count: 11, percentage: 0.78 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 74631,
      reportingSchoolsEnrolment: 74578,
      enrolmentPercentage: 99.93,
      availedMeals: 55024,
      availedMealsPercentage: 73.78
    },
    {
      serialNo: 3,
      district: "ANANTAPUR",
      totalSchools: 1692,
      reported: { count: 1674, percentage: 98.94 },
      notReported: { count: 18, percentage: 1.06 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 159406,
      reportingSchoolsEnrolment: 158879,
      enrolmentPercentage: 99.67,
      availedMeals: 120474,
      availedMealsPercentage: 75.83
    },
    {
      serialNo: 4,
      district: "CHITTOOR",
      totalSchools: 1850,
      reported: { count: 1800, percentage: 97.30 },
      notReported: { count: 50, percentage: 2.70 },
      holiday: 0,
      mealServedPercentage: 99.8,
      mealNotServedPercentage: 0.2,
      studentEnrolment: 125000,
      reportingSchoolsEnrolment: 121625,
      enrolmentPercentage: 97.30,
      availedMeals: 108000,
      availedMealsPercentage: 88.8
    },
    {
      serialNo: 5,
      district: "EAST GODAVARI",
      totalSchools: 2200,
      reported: { count: 2150, percentage: 97.73 },
      notReported: { count: 50, percentage: 2.27 },
      holiday: 0,
      mealServedPercentage: 99.9,
      mealNotServedPercentage: 0.1,
      studentEnrolment: 180000,
      reportingSchoolsEnrolment: 175950,
      enrolmentPercentage: 97.75,
      availedMeals: 155000,
      availedMealsPercentage: 88.1
    },
    {
      serialNo: 6,
      district: "GUNTUR",
      totalSchools: 1950,
      reported: { count: 1880, percentage: 96.41 },
      notReported: { count: 70, percentage: 3.59 },
      holiday: 0,
      mealServedPercentage: 99.2,
      mealNotServedPercentage: 0.8,
      studentEnrolment: 165000,
      reportingSchoolsEnrolment: 159080,
      enrolmentPercentage: 96.41,
      availedMeals: 142000,
      availedMealsPercentage: 89.3
    },
    {
      serialNo: 7,
      district: "KRISHNA",
      totalSchools: 2100,
      reported: { count: 2050, percentage: 97.62 },
      notReported: { count: 50, percentage: 2.38 },
      holiday: 0,
      mealServedPercentage: 99.7,
      mealNotServedPercentage: 0.3,
      studentEnrolment: 185000,
      reportingSchoolsEnrolment: 180600,
      enrolmentPercentage: 97.62,
      availedMeals: 162000,
      availedMealsPercentage: 89.7
    },
    {
      serialNo: 8,
      district: "PRAKASAM",
      totalSchools: 1800,
      reported: { count: 1750, percentage: 97.22 },
      notReported: { count: 50, percentage: 2.78 },
      holiday: 0,
      mealServedPercentage: 99.5,
      mealNotServedPercentage: 0.5,
      studentEnrolment: 145000,
      reportingSchoolsEnrolment: 140970,
      enrolmentPercentage: 97.22,
      availedMeals: 125000,
      availedMealsPercentage: 88.7
    }
  ],
  "TELANGANA": [
    {
      serialNo: 1,
      district: "ADILABAD",
      totalSchools: 1200,
      reported: { count: 1150, percentage: 95.83 },
      notReported: { count: 50, percentage: 4.17 },
      holiday: 0,
      mealServedPercentage: 98.5,
      mealNotServedPercentage: 1.5,
      studentEnrolment: 85000,
      reportingSchoolsEnrolment: 81458,
      enrolmentPercentage: 95.83,
      availedMeals: 72000,
      availedMealsPercentage: 88.4
    },
    {
      serialNo: 2,
      district: "BHADRADRI KOTHAGUDEM",
      totalSchools: 950,
      reported: { count: 900, percentage: 94.74 },
      notReported: { count: 50, percentage: 5.26 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 75000,
      reportingSchoolsEnrolment: 71053,
      enrolmentPercentage: 94.74,
      availedMeals: 63000,
      availedMealsPercentage: 88.7
    },
    {
      serialNo: 3,
      district: "HYDERABAD",
      totalSchools: 800,
      reported: { count: 780, percentage: 97.5 },
      notReported: { count: 20, percentage: 2.5 },
      holiday: 0,
      mealServedPercentage: 99.2,
      mealNotServedPercentage: 0.8,
      studentEnrolment: 65000,
      reportingSchoolsEnrolment: 63375,
      enrolmentPercentage: 97.5,
      availedMeals: 58000,
      availedMealsPercentage: 91.5
    },
    {
      serialNo: 4,
      district: "JAGTIAL",
      totalSchools: 1100,
      reported: { count: 1050, percentage: 95.45 },
      notReported: { count: 50, percentage: 4.55 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 80000,
      reportingSchoolsEnrolment: 76364,
      enrolmentPercentage: 95.45,
      availedMeals: 68000,
      availedMealsPercentage: 89.1
    },
    {
      serialNo: 5,
      district: "JANGAON",
      totalSchools: 850,
      reported: { count: 800, percentage: 94.12 },
      notReported: { count: 50, percentage: 5.88 },
      holiday: 0,
      mealServedPercentage: 97.5,
      mealNotServedPercentage: 2.5,
      studentEnrolment: 60000,
      reportingSchoolsEnrolment: 56471,
      enrolmentPercentage: 94.12,
      availedMeals: 50000,
      availedMealsPercentage: 88.6
    }
  ],
  "KARNATAKA": [
    {
      serialNo: 1,
      district: "BANGALORE URBAN",
      totalSchools: 2500,
      reported: { count: 2350, percentage: 94.0 },
      notReported: { count: 150, percentage: 6.0 },
      holiday: 0,
      mealServedPercentage: 95.8,
      mealNotServedPercentage: 4.2,
      studentEnrolment: 180000,
      reportingSchoolsEnrolment: 169200,
      enrolmentPercentage: 94.0,
      availedMeals: 150000,
      availedMealsPercentage: 88.7
    },
    {
      serialNo: 2,
      district: "BELAGAVI",
      totalSchools: 3200,
      reported: { count: 3000, percentage: 93.75 },
      notReported: { count: 200, percentage: 6.25 },
      holiday: 0,
      mealServedPercentage: 94.2,
      mealNotServedPercentage: 5.8,
      studentEnrolment: 220000,
      reportingSchoolsEnrolment: 206250,
      enrolmentPercentage: 93.75,
      availedMeals: 185000,
      availedMealsPercentage: 89.7
    },
    {
      serialNo: 3,
      district: "MYSORE",
      totalSchools: 2800,
      reported: { count: 2650, percentage: 94.64 },
      notReported: { count: 150, percentage: 5.36 },
      holiday: 0,
      mealServedPercentage: 96.1,
      mealNotServedPercentage: 3.9,
      studentEnrolment: 190000,
      reportingSchoolsEnrolment: 179821,
      enrolmentPercentage: 94.64,
      availedMeals: 165000,
      availedMealsPercentage: 91.8
    }
  ],
  "TAMIL NADU": [
    {
      serialNo: 1,
      district: "CHENNAI",
      totalSchools: 1200,
      reported: { count: 1150, percentage: 95.83 },
      notReported: { count: 50, percentage: 4.17 },
      holiday: 0,
      mealServedPercentage: 98.5,
      mealNotServedPercentage: 1.5,
      studentEnrolment: 95000,
      reportingSchoolsEnrolment: 91042,
      enrolmentPercentage: 95.83,
      availedMeals: 82000,
      availedMealsPercentage: 90.1
    },
    {
      serialNo: 2,
      district: "COIMBATORE",
      totalSchools: 1800,
      reported: { count: 1720, percentage: 95.56 },
      notReported: { count: 80, percentage: 4.44 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 140000,
      reportingSchoolsEnrolment: 133778,
      enrolmentPercentage: 95.56,
      availedMeals: 120000,
      availedMealsPercentage: 89.7
    },
    {
      serialNo: 3,
      district: "MADURAI",
      totalSchools: 2200,
      reported: { count: 2100, percentage: 95.45 },
      notReported: { count: 100, percentage: 4.55 },
      holiday: 0,
      mealServedPercentage: 96.8,
      mealNotServedPercentage: 3.2,
      studentEnrolment: 180000,
      reportingSchoolsEnrolment: 171818,
      enrolmentPercentage: 95.45,
      availedMeals: 150000,
      availedMealsPercentage: 87.3
    },
    {
      serialNo: 4,
      district: "SALEM",
      totalSchools: 1600,
      reported: { count: 1520, percentage: 95.0 },
      notReported: { count: 80, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 97.2,
      mealNotServedPercentage: 2.8,
      studentEnrolment: 125000,
      reportingSchoolsEnrolment: 118750,
      enrolmentPercentage: 95.0,
      availedMeals: 105000,
      availedMealsPercentage: 88.4
    },
    {
      serialNo: 5,
      district: "TIRUCHIRAPPALLI",
      totalSchools: 1400,
      reported: { count: 1330, percentage: 95.0 },
      notReported: { count: 70, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 110000,
      reportingSchoolsEnrolment: 104500,
      enrolmentPercentage: 95.0,
      availedMeals: 92000,
      availedMealsPercentage: 88.0
    },
    {
      serialNo: 6,
      district: "VELLORE",
      totalSchools: 1300,
      reported: { count: 1235, percentage: 95.0 },
      notReported: { count: 65, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 96.5,
      mealNotServedPercentage: 3.5,
      studentEnrolment: 100000,
      reportingSchoolsEnrolment: 95000,
      enrolmentPercentage: 95.0,
      availedMeals: 85000,
      availedMealsPercentage: 89.5
    },
    {
      serialNo: 7,
      district: "THANJAVUR",
      totalSchools: 1100,
      reported: { count: 1045, percentage: 95.0 },
      notReported: { count: 55, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 85000,
      reportingSchoolsEnrolment: 80750,
      enrolmentPercentage: 95.0,
      availedMeals: 72000,
      availedMealsPercentage: 89.2
    },
    {
      serialNo: 8,
      district: "TIRUNELVELI",
      totalSchools: 1200,
      reported: { count: 1140, percentage: 95.0 },
      notReported: { count: 60, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 96.2,
      mealNotServedPercentage: 3.8,
      studentEnrolment: 95000,
      reportingSchoolsEnrolment: 90250,
      enrolmentPercentage: 95.0,
      availedMeals: 80000,
      availedMealsPercentage: 88.6
    }
  ],
  "DELHI": [
    {
      serialNo: 1,
      district: "NEW DELHI",
      totalSchools: 350,
      reported: { count: 335, percentage: 95.71 },
      notReported: { count: 15, percentage: 4.29 },
      holiday: 0,
      mealServedPercentage: 98.5,
      mealNotServedPercentage: 1.5,
      studentEnrolment: 55000,
      reportingSchoolsEnrolment: 52679,
      enrolmentPercentage: 95.71,
      availedMeals: 46500,
      availedMealsPercentage: 88.3
    },
    {
      serialNo: 2,
      district: "CENTRAL DELHI",
      totalSchools: 280,
      reported: { count: 268, percentage: 95.71 },
      notReported: { count: 12, percentage: 4.29 },
      holiday: 0,
      mealServedPercentage: 98.2,
      mealNotServedPercentage: 1.8,
      studentEnrolment: 45000,
      reportingSchoolsEnrolment: 43071,
      enrolmentPercentage: 95.71,
      availedMeals: 38000,
      availedMealsPercentage: 88.2
    },
    {
      serialNo: 3,
      district: "NORTH DELHI",
      totalSchools: 320,
      reported: { count: 306, percentage: 95.63 },
      notReported: { count: 14, percentage: 4.37 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 52000,
      reportingSchoolsEnrolment: 49727,
      enrolmentPercentage: 95.63,
      availedMeals: 44000,
      availedMealsPercentage: 88.5
    },
    {
      serialNo: 4,
      district: "SOUTH DELHI",
      totalSchools: 380,
      reported: { count: 364, percentage: 95.79 },
      notReported: { count: 16, percentage: 4.21 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 62000,
      reportingSchoolsEnrolment: 59390,
      enrolmentPercentage: 95.79,
      availedMeals: 52500,
      availedMealsPercentage: 88.4
    },
    {
      serialNo: 5,
      district: "EAST DELHI",
      totalSchools: 290,
      reported: { count: 278, percentage: 95.86 },
      notReported: { count: 12, percentage: 4.14 },
      holiday: 0,
      mealServedPercentage: 97.5,
      mealNotServedPercentage: 2.5,
      studentEnrolment: 48000,
      reportingSchoolsEnrolment: 46014,
      enrolmentPercentage: 95.86,
      availedMeals: 40500,
      availedMealsPercentage: 88.0
    },
    {
      serialNo: 6,
      district: "WEST DELHI",
      totalSchools: 340,
      reported: { count: 325, percentage: 95.59 },
      notReported: { count: 15, percentage: 4.41 },
      holiday: 0,
      mealServedPercentage: 97.9,
      mealNotServedPercentage: 2.1,
      studentEnrolment: 56000,
      reportingSchoolsEnrolment: 53531,
      enrolmentPercentage: 95.59,
      availedMeals: 47000,
      availedMealsPercentage: 87.8
    },
    {
      serialNo: 7,
      district: "NORTH WEST DELHI",
      totalSchools: 310,
      reported: { count: 297, percentage: 95.81 },
      notReported: { count: 13, percentage: 4.19 },
      holiday: 0,
      mealServedPercentage: 98.3,
      mealNotServedPercentage: 1.7,
      studentEnrolment: 51000,
      reportingSchoolsEnrolment: 48863,
      enrolmentPercentage: 95.81,
      availedMeals: 43000,
      availedMealsPercentage: 88.0
    },
    {
      serialNo: 8,
      district: "SOUTH WEST DELHI",
      totalSchools: 330,
      reported: { count: 316, percentage: 95.76 },
      notReported: { count: 14, percentage: 4.24 },
      holiday: 0,
      mealServedPercentage: 97.6,
      mealNotServedPercentage: 2.4,
      studentEnrolment: 54000,
      reportingSchoolsEnrolment: 51711,
      enrolmentPercentage: 95.76,
      availedMeals: 45500,
      availedMealsPercentage: 88.0
    },
    {
      serialNo: 9,
      district: "SHAHDARA",
      totalSchools: 300,
      reported: { count: 287, percentage: 95.67 },
      notReported: { count: 13, percentage: 4.33 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 49000,
      reportingSchoolsEnrolment: 46878,
      enrolmentPercentage: 95.67,
      availedMeals: 41000,
      availedMealsPercentage: 87.5
    },
    {
      serialNo: 10,
      district: "DWARKA",
      totalSchools: 290,
      reported: { count: 278, percentage: 95.86 },
      notReported: { count: 12, percentage: 4.14 },
      holiday: 0,
      mealServedPercentage: 98.0,
      mealNotServedPercentage: 2.0,
      studentEnrolment: 47000,
      reportingSchoolsEnrolment: 45055,
      enrolmentPercentage: 95.86,
      availedMeals: 39500,
      availedMealsPercentage: 87.7
    }
  ]
};

// Block level data
export const blockMealData: { [district: string]: BlockMealData[] } = {
  "ANAKAPALLI": [
    {
      serialNo: 1,
      block: "BUTCHIAHPETA",
      totalSchools: 45,
      reported: { count: 44, percentage: 97.78 },
      notReported: { count: 1, percentage: 2.22 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 2500,
      reportingSchoolsEnrolment: 2445,
      enrolmentPercentage: 97.8,
      availedMeals: 1850,
      availedMealsPercentage: 75.7
    },
    {
      serialNo: 2,
      block: "ANAKAPALLI",
      totalSchools: 52,
      reported: { count: 51, percentage: 98.08 },
      notReported: { count: 1, percentage: 1.92 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 2800,
      reportingSchoolsEnrolment: 2746,
      enrolmentPercentage: 98.07,
      availedMeals: 2100,
      availedMealsPercentage: 76.5
    },
    {
      serialNo: 3,
      block: "CHODAVARAM",
      totalSchools: 38,
      reported: { count: 37, percentage: 97.37 },
      notReported: { count: 1, percentage: 2.63 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 2100,
      reportingSchoolsEnrolment: 2045,
      enrolmentPercentage: 97.37,
      availedMeals: 1650,
      availedMealsPercentage: 80.7
    },
    {
      serialNo: 4,
      block: "DEVARAPALLI",
      totalSchools: 42,
      reported: { count: 41, percentage: 97.62 },
      notReported: { count: 1, percentage: 2.38 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 2300,
      reportingSchoolsEnrolment: 2245,
      enrolmentPercentage: 97.62,
      availedMeals: 1800,
      availedMealsPercentage: 80.2
    }
  ],
  "ALLURI SITHARAMA RAJU": [
    {
      serialNo: 1,
      block: "PADERU",
      totalSchools: 38,
      reported: { count: 37, percentage: 97.37 },
      notReported: { count: 1, percentage: 2.63 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 1200,
      reportingSchoolsEnrolment: 1168,
      enrolmentPercentage: 97.33,
      availedMeals: 1050,
      availedMealsPercentage: 89.9
    },
    {
      serialNo: 2,
      block: "MUNCHINGPUT",
      totalSchools: 35,
      reported: { count: 34, percentage: 97.14 },
      notReported: { count: 1, percentage: 2.86 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 1100,
      reportingSchoolsEnrolment: 1069,
      enrolmentPercentage: 97.18,
      availedMeals: 950,
      availedMealsPercentage: 88.9
    },
    {
      serialNo: 3,
      block: "PEDABAYALU",
      totalSchools: 32,
      reported: { count: 31, percentage: 96.88 },
      notReported: { count: 1, percentage: 3.12 },
      holiday: 0,
      mealServedPercentage: 100,
      mealNotServedPercentage: 0,
      studentEnrolment: 950,
      reportingSchoolsEnrolment: 920,
      enrolmentPercentage: 96.84,
      availedMeals: 820,
      availedMealsPercentage: 89.1
    }
  ],
  "GUNTUR": [
    {
      serialNo: 1,
      block: "GUNTUR",
      totalSchools: 48,
      reported: { count: 46, percentage: 95.83 },
      notReported: { count: 2, percentage: 4.17 },
      holiday: 0,
      mealServedPercentage: 99.2,
      mealNotServedPercentage: 0.8,
      studentEnrolment: 3200,
      reportingSchoolsEnrolment: 3067,
      enrolmentPercentage: 95.84,
      availedMeals: 2750,
      availedMealsPercentage: 89.6
    },
    {
      serialNo: 2,
      block: "TENALI",
      totalSchools: 42,
      reported: { count: 40, percentage: 95.24 },
      notReported: { count: 2, percentage: 4.76 },
      holiday: 0,
      mealServedPercentage: 99.1,
      mealNotServedPercentage: 0.9,
      studentEnrolment: 2800,
      reportingSchoolsEnrolment: 2667,
      enrolmentPercentage: 95.25,
      availedMeals: 2400,
      availedMealsPercentage: 90.0
    }
  ],
  "HYDERABAD": [
    {
      serialNo: 1,
      block: "HYDERABAD URBAN",
      totalSchools: 65,
      reported: { count: 63, percentage: 96.92 },
      notReported: { count: 2, percentage: 3.08 },
      holiday: 0,
      mealServedPercentage: 99.2,
      mealNotServedPercentage: 0.8,
      studentEnrolment: 4200,
      reportingSchoolsEnrolment: 4071,
      enrolmentPercentage: 96.93,
      availedMeals: 3750,
      availedMealsPercentage: 92.1
    },
    {
      serialNo: 2,
      block: "SECUNDERABAD",
      totalSchools: 58,
      reported: { count: 56, percentage: 96.55 },
      notReported: { count: 2, percentage: 3.45 },
      holiday: 0,
      mealServedPercentage: 99.3,
      mealNotServedPercentage: 0.7,
      studentEnrolment: 3800,
      reportingSchoolsEnrolment: 3669,
      enrolmentPercentage: 96.55,
      availedMeals: 3350,
      availedMealsPercentage: 91.3
    }
  ],
  "BANGALORE URBAN": [
    {
      serialNo: 1,
      block: "BANGALORE NORTH",
      totalSchools: 85,
      reported: { count: 80, percentage: 94.12 },
      notReported: { count: 5, percentage: 5.88 },
      holiday: 0,
      mealServedPercentage: 95.8,
      mealNotServedPercentage: 4.2,
      studentEnrolment: 5200,
      reportingSchoolsEnrolment: 4889,
      enrolmentPercentage: 94.02,
      availedMeals: 4350,
      availedMealsPercentage: 89.0
    },
    {
      serialNo: 2,
      block: "BANGALORE SOUTH",
      totalSchools: 78,
      reported: { count: 73, percentage: 93.59 },
      notReported: { count: 5, percentage: 6.41 },
      holiday: 0,
      mealServedPercentage: 95.5,
      mealNotServedPercentage: 4.5,
      studentEnrolment: 4800,
      reportingSchoolsEnrolment: 4492,
      enrolmentPercentage: 93.58,
      availedMeals: 4000,
      availedMealsPercentage: 89.0
    }
  ],
  "MADURAI": [
    {
      serialNo: 1,
      block: "MADURAI NORTH",
      totalSchools: 95,
      reported: { count: 90, percentage: 94.74 },
      notReported: { count: 5, percentage: 5.26 },
      holiday: 0,
      mealServedPercentage: 96.8,
      mealNotServedPercentage: 3.2,
      studentEnrolment: 6200,
      reportingSchoolsEnrolment: 5874,
      enrolmentPercentage: 94.74,
      availedMeals: 5200,
      availedMealsPercentage: 88.5
    },
    {
      serialNo: 2,
      block: "MADURAI SOUTH",
      totalSchools: 88,
      reported: { count: 84, percentage: 95.45 },
      notReported: { count: 4, percentage: 4.55 },
      holiday: 0,
      mealServedPercentage: 97.2,
      mealNotServedPercentage: 2.8,
      studentEnrolment: 5800,
      reportingSchoolsEnrolment: 5536,
      enrolmentPercentage: 95.45,
      availedMeals: 4900,
      availedMealsPercentage: 88.5
    },
    {
      serialNo: 3,
      block: "MELUR",
      totalSchools: 75,
      reported: { count: 71, percentage: 94.67 },
      notReported: { count: 4, percentage: 5.33 },
      holiday: 0,
      mealServedPercentage: 96.5,
      mealNotServedPercentage: 3.5,
      studentEnrolment: 4800,
      reportingSchoolsEnrolment: 4544,
      enrolmentPercentage: 94.67,
      availedMeals: 4000,
      availedMealsPercentage: 88.0
    }
  ],
  "SALEM": [
    {
      serialNo: 1,
      block: "SALEM NORTH",
      totalSchools: 72,
      reported: { count: 68, percentage: 94.44 },
      notReported: { count: 4, percentage: 5.56 },
      holiday: 0,
      mealServedPercentage: 97.2,
      mealNotServedPercentage: 2.8,
      studentEnrolment: 4500,
      reportingSchoolsEnrolment: 4250,
      enrolmentPercentage: 94.44,
      availedMeals: 3800,
      availedMealsPercentage: 89.4
    },
    {
      serialNo: 2,
      block: "SALEM SOUTH",
      totalSchools: 68,
      reported: { count: 65, percentage: 95.59 },
      notReported: { count: 3, percentage: 4.41 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 4200,
      reportingSchoolsEnrolment: 4015,
      enrolmentPercentage: 95.59,
      availedMeals: 3600,
      availedMealsPercentage: 89.7
    },
    {
      serialNo: 3,
      block: "METTUR",
      totalSchools: 65,
      reported: { count: 62, percentage: 95.38 },
      notReported: { count: 3, percentage: 4.62 },
      holiday: 0,
      mealServedPercentage: 96.9,
      mealNotServedPercentage: 3.1,
      studentEnrolment: 4000,
      reportingSchoolsEnrolment: 3815,
      enrolmentPercentage: 95.38,
      availedMeals: 3300,
      availedMealsPercentage: 86.5
    }
  ],
  "TIRUCHIRAPPALLI": [
    {
      serialNo: 1,
      block: "TIRUCHIRAPPALLI NORTH",
      totalSchools: 70,
      reported: { count: 66, percentage: 94.29 },
      notReported: { count: 4, percentage: 5.71 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 4800,
      reportingSchoolsEnrolment: 4526,
      enrolmentPercentage: 94.29,
      availedMeals: 4000,
      availedMealsPercentage: 88.4
    },
    {
      serialNo: 2,
      block: "TIRUCHIRAPPALLI SOUTH",
      totalSchools: 65,
      reported: { count: 62, percentage: 95.38 },
      notReported: { count: 3, percentage: 4.62 },
      holiday: 0,
      mealServedPercentage: 98.5,
      mealNotServedPercentage: 1.5,
      studentEnrolment: 4400,
      reportingSchoolsEnrolment: 4192,
      enrolmentPercentage: 95.38,
      availedMeals: 3700,
      availedMealsPercentage: 88.3
    },
    {
      serialNo: 3,
      block: "SRIRANGAM",
      totalSchools: 60,
      reported: { count: 57, percentage: 95.0 },
      notReported: { count: 3, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 3800,
      reportingSchoolsEnrolment: 3610,
      enrolmentPercentage: 95.0,
      availedMeals: 3200,
      availedMealsPercentage: 88.6
    }
  ],
  "VELLORE": [
    {
      serialNo: 1,
      block: "VELLORE NORTH",
      totalSchools: 68,
      reported: { count: 65, percentage: 95.59 },
      notReported: { count: 3, percentage: 4.41 },
      holiday: 0,
      mealServedPercentage: 96.5,
      mealNotServedPercentage: 3.5,
      studentEnrolment: 4200,
      reportingSchoolsEnrolment: 4015,
      enrolmentPercentage: 95.59,
      availedMeals: 3600,
      availedMealsPercentage: 89.7
    },
    {
      serialNo: 2,
      block: "VELLORE SOUTH",
      totalSchools: 62,
      reported: { count: 59, percentage: 95.16 },
      notReported: { count: 3, percentage: 4.84 },
      holiday: 0,
      mealServedPercentage: 96.8,
      mealNotServedPercentage: 3.2,
      studentEnrolment: 3800,
      reportingSchoolsEnrolment: 3615,
      enrolmentPercentage: 95.16,
      availedMeals: 3200,
      availedMealsPercentage: 88.5
    },
    {
      serialNo: 3,
      block: "KATPAADI",
      totalSchools: 58,
      reported: { count: 55, percentage: 94.83 },
      notReported: { count: 3, percentage: 5.17 },
      holiday: 0,
      mealServedPercentage: 96.2,
      mealNotServedPercentage: 3.8,
      studentEnrolment: 3500,
      reportingSchoolsEnrolment: 3320,
      enrolmentPercentage: 94.83,
      availedMeals: 2800,
      availedMealsPercentage: 84.3
    }
  ],
  "THANJAVUR": [
    {
      serialNo: 1,
      block: "THANJAVUR NORTH",
      totalSchools: 60,
      reported: { count: 57, percentage: 95.0 },
      notReported: { count: 3, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 3800,
      reportingSchoolsEnrolment: 3610,
      enrolmentPercentage: 95.0,
      availedMeals: 3200,
      availedMealsPercentage: 88.7
    },
    {
      serialNo: 2,
      block: "THANJAVUR SOUTH",
      totalSchools: 55,
      reported: { count: 52, percentage: 94.55 },
      notReported: { count: 3, percentage: 5.45 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 3400,
      reportingSchoolsEnrolment: 3215,
      enrolmentPercentage: 94.55,
      availedMeals: 2800,
      availedMealsPercentage: 87.1
    },
    {
      serialNo: 3,
      block: "KUMBAKONAM",
      totalSchools: 52,
      reported: { count: 49, percentage: 94.23 },
      notReported: { count: 3, percentage: 5.77 },
      holiday: 0,
      mealServedPercentage: 97.5,
      mealNotServedPercentage: 2.5,
      studentEnrolment: 3200,
      reportingSchoolsEnrolment: 3015,
      enrolmentPercentage: 94.23,
      availedMeals: 2600,
      availedMealsPercentage: 86.2
    }
  ],
  "TIRUNELVELI": [
    {
      serialNo: 1,
      block: "TIRUNELVELI NORTH",
      totalSchools: 65,
      reported: { count: 62, percentage: 95.38 },
      notReported: { count: 3, percentage: 4.62 },
      holiday: 0,
      mealServedPercentage: 96.2,
      mealNotServedPercentage: 3.8,
      studentEnrolment: 4200,
      reportingSchoolsEnrolment: 4004,
      enrolmentPercentage: 95.38,
      availedMeals: 3500,
      availedMealsPercentage: 87.4
    },
    {
      serialNo: 2,
      block: "TIRUNELVELI SOUTH",
      totalSchools: 60,
      reported: { count: 57, percentage: 95.0 },
      notReported: { count: 3, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 96.5,
      mealNotServedPercentage: 3.5,
      studentEnrolment: 3800,
      reportingSchoolsEnrolment: 3610,
      enrolmentPercentage: 95.0,
      availedMeals: 3200,
      availedMealsPercentage: 88.6
    },
    {
      serialNo: 3,
      block: "PALAYAMKOTTAI",
      totalSchools: 55,
      reported: { count: 52, percentage: 94.55 },
      notReported: { count: 3, percentage: 5.45 },
      holiday: 0,
      mealServedPercentage: 95.8,
      mealNotServedPercentage: 4.2,
      studentEnrolment: 3400,
      reportingSchoolsEnrolment: 3215,
      enrolmentPercentage: 94.55,
      availedMeals: 2800,
      availedMealsPercentage: 87.1
    }
  ],
  "NEW DELHI": [
    {
      serialNo: 1,
      block: "CONNAUGHT PLACE",
      totalSchools: 45,
      reported: { count: 43, percentage: 95.56 },
      notReported: { count: 2, percentage: 4.44 },
      holiday: 0,
      mealServedPercentage: 98.5,
      mealNotServedPercentage: 1.5,
      studentEnrolment: 7200,
      reportingSchoolsEnrolment: 6880,
      enrolmentPercentage: 95.56,
      availedMeals: 6100,
      availedMealsPercentage: 88.7
    },
    {
      serialNo: 2,
      block: "CHANAKYAPURI",
      totalSchools: 38,
      reported: { count: 36, percentage: 94.74 },
      notReported: { count: 2, percentage: 5.26 },
      holiday: 0,
      mealServedPercentage: 98.2,
      mealNotServedPercentage: 1.8,
      studentEnrolment: 6100,
      reportingSchoolsEnrolment: 5783,
      enrolmentPercentage: 94.74,
      availedMeals: 5100,
      availedMealsPercentage: 88.2
    },
    {
      serialNo: 3,
      block: "PARLIAMENT STREET",
      totalSchools: 42,
      reported: { count: 40, percentage: 95.24 },
      notReported: { count: 2, percentage: 4.76 },
      holiday: 0,
      mealServedPercentage: 98.8,
      mealNotServedPercentage: 1.2,
      studentEnrolment: 6800,
      reportingSchoolsEnrolment: 6476,
      enrolmentPercentage: 95.24,
      availedMeals: 5700,
      availedMealsPercentage: 88.0
    }
  ],
  "SOUTH DELHI": [
    {
      serialNo: 1,
      block: "SAKET",
      totalSchools: 52,
      reported: { count: 50, percentage: 96.15 },
      notReported: { count: 2, percentage: 3.85 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 8500,
      reportingSchoolsEnrolment: 8173,
      enrolmentPercentage: 96.15,
      availedMeals: 7200,
      availedMealsPercentage: 88.1
    },
    {
      serialNo: 2,
      block: "GREATER KAILASH",
      totalSchools: 48,
      reported: { count: 46, percentage: 95.83 },
      notReported: { count: 2, percentage: 4.17 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 7800,
      reportingSchoolsEnrolment: 7474,
      enrolmentPercentage: 95.83,
      availedMeals: 6600,
      availedMealsPercentage: 88.3
    },
    {
      serialNo: 3,
      block: "DEFENCE COLONY",
      totalSchools: 44,
      reported: { count: 42, percentage: 95.45 },
      notReported: { count: 2, percentage: 4.55 },
      holiday: 0,
      mealServedPercentage: 98.3,
      mealNotServedPercentage: 1.7,
      studentEnrolment: 7200,
      reportingSchoolsEnrolment: 6873,
      enrolmentPercentage: 95.45,
      availedMeals: 6100,
      availedMealsPercentage: 88.8
    }
  ],
  "NORTH DELHI": [
    {
      serialNo: 1,
      block: "CIVIL LINES",
      totalSchools: 50,
      reported: { count: 48, percentage: 96.0 },
      notReported: { count: 2, percentage: 4.0 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 8200,
      reportingSchoolsEnrolment: 7872,
      enrolmentPercentage: 96.0,
      availedMeals: 6900,
      availedMealsPercentage: 87.6
    },
    {
      serialNo: 2,
      block: "KAMLA NAGAR",
      totalSchools: 46,
      reported: { count: 44, percentage: 95.65 },
      notReported: { count: 2, percentage: 4.35 },
      holiday: 0,
      mealServedPercentage: 98.1,
      mealNotServedPercentage: 1.9,
      studentEnrolment: 7500,
      reportingSchoolsEnrolment: 7174,
      enrolmentPercentage: 95.65,
      availedMeals: 6300,
      availedMealsPercentage: 87.8
    },
    {
      serialNo: 3,
      block: "MODEL TOWN",
      totalSchools: 42,
      reported: { count: 40, percentage: 95.24 },
      notReported: { count: 2, percentage: 4.76 },
      holiday: 0,
      mealServedPercentage: 97.5,
      mealNotServedPercentage: 2.5,
      studentEnrolment: 6800,
      reportingSchoolsEnrolment: 6476,
      enrolmentPercentage: 95.24,
      availedMeals: 5700,
      availedMealsPercentage: 88.0
    }
  ],
  "DWARKA": [
    {
      serialNo: 1,
      block: "DWARKA SECTOR 1-8",
      totalSchools: 48,
      reported: { count: 46, percentage: 95.83 },
      notReported: { count: 2, percentage: 4.17 },
      holiday: 0,
      mealServedPercentage: 98.0,
      mealNotServedPercentage: 2.0,
      studentEnrolment: 7800,
      reportingSchoolsEnrolment: 7474,
      enrolmentPercentage: 95.83,
      availedMeals: 6500,
      availedMealsPercentage: 87.0
    },
    {
      serialNo: 2,
      block: "DWARKA SECTOR 9-14",
      totalSchools: 44,
      reported: { count: 42, percentage: 95.45 },
      notReported: { count: 2, percentage: 4.55 },
      holiday: 0,
      mealServedPercentage: 97.8,
      mealNotServedPercentage: 2.2,
      studentEnrolment: 7200,
      reportingSchoolsEnrolment: 6873,
      enrolmentPercentage: 95.45,
      availedMeals: 6000,
      availedMealsPercentage: 87.3
    },
    {
      serialNo: 3,
      block: "DWARKA SECTOR 15-23",
      totalSchools: 40,
      reported: { count: 38, percentage: 95.0 },
      notReported: { count: 2, percentage: 5.0 },
      holiday: 0,
      mealServedPercentage: 98.2,
      mealNotServedPercentage: 1.8,
      studentEnrolment: 6500,
      reportingSchoolsEnrolment: 6175,
      enrolmentPercentage: 95.0,
      availedMeals: 5400,
      availedMealsPercentage: 87.5
    }
  ]
};

// Village level data
export const villageMealData: { [block: string]: VillageMealData[] } = {
  "BUTCHIAHPETA": [
    {
      serialNo: 1,
      udiseCode: "28132000701",
      schoolName: "0320311 - MPPS CHINAPPANNAPALEM",
      category: "Primary",
      type: "Local Body",
      enrolment: 21,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 7
    },
    {
      serialNo: 2,
      udiseCode: "28132000702",
      schoolName: "0320312 - MPPS BUTCHIAHPETA",
      category: "Primary",
      type: "Local Body",
      enrolment: 45,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 38
    },
    {
      serialNo: 3,
      udiseCode: "28132000703",
      schoolName: "0320313 - MPPS KONDAPALLI",
      category: "Primary",
      type: "Local Body",
      enrolment: 32,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 28
    },
    {
      serialNo: 4,
      udiseCode: "28132000704",
      schoolName: "0320314 - MPPS GANGUVARAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 28,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 24
    },
    {
      serialNo: 5,
      udiseCode: "28132000705",
      schoolName: "0320315 - MPPS KOTHAVEEDHI",
      category: "Primary",
      type: "Local Body",
      enrolment: 35,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 30
    }
  ],
  "ANAKAPALLI": [
    {
      serialNo: 1,
      udiseCode: "28132000801",
      schoolName: "0320316 - MPPS ANAKAPALLI",
      category: "Primary",
      type: "Local Body",
      enrolment: 65,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 58
    },
    {
      serialNo: 2,
      udiseCode: "28132000802",
      schoolName: "0320317 - MPPS GUDEM",
      category: "Primary",
      type: "Local Body",
      enrolment: 28,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 25
    },
    {
      serialNo: 3,
      udiseCode: "28132000803",
      schoolName: "0320318 - MPPS KASIMKOTA",
      category: "Primary",
      type: "Local Body",
      enrolment: 42,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 38
    },
    {
      serialNo: 4,
      udiseCode: "28132000804",
      schoolName: "0320319 - MPPS NAKKAPALLI",
      category: "Primary",
      type: "Local Body",
      enrolment: 38,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 34
    }
  ],
  "PADERU": [
    {
      serialNo: 1,
      udiseCode: "28132000901",
      schoolName: "0320320 - MPPS PADERU",
      category: "Primary",
      type: "Local Body",
      enrolment: 55,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 48
    },
    {
      serialNo: 2,
      udiseCode: "28132000902",
      schoolName: "0320321 - MPPS GUDEM",
      category: "Primary",
      type: "Local Body",
      enrolment: 32,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 28
    },
    {
      serialNo: 3,
      udiseCode: "28132000903",
      schoolName: "0320322 - MPPS KONDAPALLI",
      category: "Primary",
      type: "Local Body",
      enrolment: 25,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 22
    }
  ],
  "GUNTUR": [
    {
      serialNo: 1,
      udiseCode: "28132001001",
      schoolName: "0320323 - MPPS GUNTUR",
      category: "Primary",
      type: "Local Body",
      enrolment: 75,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 68
    },
    {
      serialNo: 2,
      udiseCode: "28132001002",
      schoolName: "0320324 - MPPS TENALI",
      category: "Primary",
      type: "Local Body",
      enrolment: 62,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 56
    },
    {
      serialNo: 3,
      udiseCode: "28132001003",
      schoolName: "0320325 - MPPS MANGALAGIRI",
      category: "Primary",
      type: "Local Body",
      enrolment: 48,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 43
    }
  ],
  "HYDERABAD URBAN": [
    {
      serialNo: 1,
      udiseCode: "28132001101",
      schoolName: "0320326 - MPPS HYDERABAD",
      category: "Primary",
      type: "Local Body",
      enrolment: 85,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 78
    },
    {
      serialNo: 2,
      udiseCode: "28132001102",
      schoolName: "0320327 - MPPS SECUNDERABAD",
      category: "Primary",
      type: "Local Body",
      enrolment: 72,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 66
    },
    {
      serialNo: 3,
      udiseCode: "28132001103",
      schoolName: "0320328 - MPPS BANJARA HILLS",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 52
    }
  ],
  "BANGALORE NORTH": [
    {
      serialNo: 1,
      udiseCode: "28132001201",
      schoolName: "0320329 - MPPS BANGALORE NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 92,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 82
    },
    {
      serialNo: 2,
      udiseCode: "28132001202",
      schoolName: "0320330 - MPPS HEBBAL",
      category: "Primary",
      type: "Local Body",
      enrolment: 68,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 61
    },
    {
      serialNo: 3,
      udiseCode: "28132001203",
      schoolName: "0320331 - MPPS YELAHANKA",
      category: "Primary",
      type: "Local Body",
      enrolment: 55,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 49
    }
  ],
  "MADURAI NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000101",
      schoolName: "0330001 - MPPS MADURAI NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 78,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 72
    },
    {
      serialNo: 2,
      udiseCode: "33132000102",
      schoolName: "0330002 - MPPS ANNA NAGAR",
      category: "Primary",
      type: "Local Body",
      enrolment: 65,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 60
    },
    {
      serialNo: 3,
      udiseCode: "33132000103",
      schoolName: "0330003 - MPPS K.K. NAGAR",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    },
    {
      serialNo: 4,
      udiseCode: "33132000104",
      schoolName: "0330004 - MPPS VILLAPURAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 45,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 42
    },
    {
      serialNo: 5,
      udiseCode: "33132000105",
      schoolName: "0330005 - MPPS THIRUPPARANKUNDRAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 52,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 48
    }
  ],
  "MADURAI SOUTH": [
    {
      serialNo: 1,
      udiseCode: "33132000201",
      schoolName: "0330006 - MPPS MADURAI SOUTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 82,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 76
    },
    {
      serialNo: 2,
      udiseCode: "33132000202",
      schoolName: "0330007 - MPPS GORIPALAYAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 68,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 63
    },
    {
      serialNo: 3,
      udiseCode: "33132000203",
      schoolName: "0330008 - MPPS KALLAZAGAR",
      category: "Primary",
      type: "Local Body",
      enrolment: 55,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 51
    },
    {
      serialNo: 4,
      udiseCode: "33132000204",
      schoolName: "0330009 - MPPS ALANGANALLUR",
      category: "Primary",
      type: "Local Body",
      enrolment: 48,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 44
    }
  ],
  "SALEM NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000301",
      schoolName: "0330010 - MPPS SALEM NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 75,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 69
    },
    {
      serialNo: 2,
      udiseCode: "33132000302",
      schoolName: "0330011 - MPPS HASTHAMPATTI",
      category: "Primary",
      type: "Local Body",
      enrolment: 62,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 57
    },
    {
      serialNo: 3,
      udiseCode: "33132000303",
      schoolName: "0330012 - MPPS SUYAMBU",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    },
    {
      serialNo: 4,
      udiseCode: "33132000304",
      schoolName: "0330013 - MPPS KONDALAMPATTI",
      category: "Primary",
      type: "Local Body",
      enrolment: 45,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 41
    }
  ],
  "TIRUCHIRAPPALLI NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000401",
      schoolName: "0330014 - MPPS TIRUCHIRAPPALLI NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 88,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 82
    },
    {
      serialNo: 2,
      udiseCode: "33132000402",
      schoolName: "0330015 - MPPS THIRUVANAIKOVIL",
      category: "Primary",
      type: "Local Body",
      enrolment: 72,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 67
    },
    {
      serialNo: 3,
      udiseCode: "33132000403",
      schoolName: "0330016 - MPPS SAMAYAPURAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 65,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 60
    },
    {
      serialNo: 4,
      udiseCode: "33132000404",
      schoolName: "0330017 - MPPS THIRUVERUMBUR",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 54
    }
  ],
  "VELLORE NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000501",
      schoolName: "0330018 - MPPS VELLORE NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 85,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 79
    },
    {
      serialNo: 2,
      udiseCode: "33132000502",
      schoolName: "0330019 - MPPS KATPAADI",
      category: "Primary",
      type: "Local Body",
      enrolment: 70,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 65
    },
    {
      serialNo: 3,
      udiseCode: "33132000503",
      schoolName: "0330020 - MPPS MELVISHARAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 62,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 57
    },
    {
      serialNo: 4,
      udiseCode: "33132000504",
      schoolName: "0330021 - MPPS WALAJAPET",
      category: "Primary",
      type: "Local Body",
      enrolment: 55,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 51
    }
  ],
  "THANJAVUR NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000601",
      schoolName: "0330022 - MPPS THANJAVUR NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 80,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 74
    },
    {
      serialNo: 2,
      udiseCode: "33132000602",
      schoolName: "0330023 - MPPS KUMBAKONAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 68,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 63
    },
    {
      serialNo: 3,
      udiseCode: "33132000603",
      schoolName: "0330024 - MPPS PATTUKOTTAI",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    },
    {
      serialNo: 4,
      udiseCode: "33132000604",
      schoolName: "0330025 - MPPS ORATHANADU",
      category: "Primary",
      type: "Local Body",
      enrolment: 52,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 48
    }
  ],
  "TIRUNELVELI NORTH": [
    {
      serialNo: 1,
      udiseCode: "33132000701",
      schoolName: "0330026 - MPPS TIRUNELVELI NORTH",
      category: "Primary",
      type: "Local Body",
      enrolment: 78,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 72
    },
    {
      serialNo: 2,
      udiseCode: "33132000702",
      schoolName: "0330027 - MPPS PALAYAMKOTTAI",
      category: "Primary",
      type: "Local Body",
      enrolment: 65,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 60
    },
    {
      serialNo: 3,
      udiseCode: "33132000703",
      schoolName: "0330028 - MPPS AMBASAMUDRAM",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    },
    {
      serialNo: 4,
      udiseCode: "33132000704",
      schoolName: "0330029 - MPPS TENKASI",
      category: "Primary",
      type: "Local Body",
      enrolment: 48,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 44
    }
  ],
  "CONNAUGHT PLACE": [
    {
      serialNo: 1,
      udiseCode: "07132000101",
      schoolName: "0700001 - MCDPS CONNAUGHT PLACE",
      category: "Primary",
      type: "Local Body",
      enrolment: 85,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 78
    },
    {
      serialNo: 2,
      udiseCode: "07132000102",
      schoolName: "0700002 - MCDPS JANPATH",
      category: "Primary",
      type: "Local Body",
      enrolment: 72,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 66
    },
    {
      serialNo: 3,
      udiseCode: "07132000103",
      schoolName: "0700003 - MCDPS BARAKHAMBA ROAD",
      category: "Primary",
      type: "Local Body",
      enrolment: 68,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 62
    },
    {
      serialNo: 4,
      udiseCode: "07132000104",
      schoolName: "0700004 - MCDPS KASTURBA GANDHI MARG",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    }
  ],
  "SAKET": [
    {
      serialNo: 1,
      udiseCode: "07132000201",
      schoolName: "0700005 - MCDPS SAKET",
      category: "Primary",
      type: "Local Body",
      enrolment: 92,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 85
    },
    {
      serialNo: 2,
      udiseCode: "07132000202",
      schoolName: "0700006 - MCDPS PUSHPA VIHAR",
      category: "Primary",
      type: "Local Body",
      enrolment: 78,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 72
    },
    {
      serialNo: 3,
      udiseCode: "07132000203",
      schoolName: "0700007 - MCDPS SAKET COURT",
      category: "Primary",
      type: "Local Body",
      enrolment: 65,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 60
    },
    {
      serialNo: 4,
      udiseCode: "07132000204",
      schoolName: "0700008 - MCDPS SAKET COMMUNITY CENTRE",
      category: "Primary",
      type: "Local Body",
      enrolment: 55,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 51
    }
  ],
  "CIVIL LINES": [
    {
      serialNo: 1,
      udiseCode: "07132000301",
      schoolName: "0700009 - MCDPS CIVIL LINES",
      category: "Primary",
      type: "Local Body",
      enrolment: 88,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 81
    },
    {
      serialNo: 2,
      udiseCode: "07132000302",
      schoolName: "0700010 - MCDPS KASHMERE GATE",
      category: "Primary",
      type: "Local Body",
      enrolment: 75,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 69
    },
    {
      serialNo: 3,
      udiseCode: "07132000303",
      schoolName: "0700011 - MCDPS MAJNU KA TILA",
      category: "Primary",
      type: "Local Body",
      enrolment: 62,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 57
    },
    {
      serialNo: 4,
      udiseCode: "07132000304",
      schoolName: "0700012 - MCDPS TIMARPUR",
      category: "Primary",
      type: "Local Body",
      enrolment: 52,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 48
    }
  ],
  "DWARKA SECTOR 1-8": [
    {
      serialNo: 1,
      udiseCode: "07132000401",
      schoolName: "0700013 - MCDPS DWARKA SECTOR 1",
      category: "Primary",
      type: "Local Body",
      enrolment: 95,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 87
    },
    {
      serialNo: 2,
      udiseCode: "07132000402",
      schoolName: "0700014 - MCDPS DWARKA SECTOR 3",
      category: "Primary",
      type: "Local Body",
      enrolment: 82,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 75
    },
    {
      serialNo: 3,
      udiseCode: "07132000403",
      schoolName: "0700015 - MCDPS DWARKA SECTOR 5",
      category: "Primary",
      type: "Local Body",
      enrolment: 70,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 64
    },
    {
      serialNo: 4,
      udiseCode: "07132000404",
      schoolName: "0700016 - MCDPS DWARKA SECTOR 7",
      category: "Primary",
      type: "Local Body",
      enrolment: 58,
      holiday: "-",
      reportingStatus: "Yes",
      mealsServed: 53
    }
  ]
};